import { ACCENT_BLUE, MID_BLUE, MID_BLUE3, OFF_WHITE4, WHITE, OFF_WHITE, OFF_WHITE3, GREY2, GREY3, GREY4, GREY5, GREY6, NAVY5, NAVY8, LIGHT_BLUE4, LIGHT_GRAY, DARK_NAVY6, BACKGROUND_LIGHT, ONBOARDING_BLUE, ONBOARDING_BLUE2, LIGHT_GRAY2, NAVY15, MID_BLUE2, GREEN_PRIMARY, YELLOW1, ORANGE1, LIGHT_BLUE6, GREY11, BABY_BLUE3 } from "../colors";
import { LIGHT_MODE } from "../constants";
var attunedLightTheme = {
  mode: LIGHT_MODE,
  background: {
    "default": BACKGROUND_LIGHT,
    login: LIGHT_GRAY
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.04)'
  },
  primary: {
    main: MID_BLUE3,
    200: LIGHT_BLUE6,
    400: MID_BLUE2
  },
  secondary: {
    main: NAVY5
  },
  font: {
    primary: MID_BLUE3,
    secondary: NAVY5,
    tertiary: DARK_NAVY6,
    description: GREY6,
    disabled: {
      primary: 'rgba(0, 0, 0, 0.38)'
    },
    pageHeader: {
      primary: NAVY8
    }
  },
  inputField: {
    primary: OFF_WHITE4
  },
  hr: {
    primary: GREY2
  },
  content: {
    primary: WHITE,
    secondary: OFF_WHITE
  },
  popover: {
    primary: WHITE,
    hover: {
      primary: OFF_WHITE
    }
  },
  title: {
    primary: GREY3,
    background: GREY3,
    border: "1px solid ".concat(GREY5)
  },
  paginatedLoadingMessage: {
    background: {
      primary: LIGHT_BLUE4
    },
    text: {
      primary: 'white'
    }
  },
  table: {
    row: {
      hover: {
        primary: 'rgba(0, 0, 0, 0.04)'
      },
      border: '1px solid rgba(224, 224, 224, 1)'
    },
    filter: {
      primary: 'white',
      secondary: 'white'
    },
    card: {
      background: {
        primary: OFF_WHITE
      }
    },
    selected: {
      background: {
        primary: OFF_WHITE4
      }
    }
  },
  specialButton: {
    primary: MID_BLUE,
    secondary: GREY4
  },
  paper: {
    background: {
      secondary: LIGHT_GRAY
    }
  },
  rectangularOption: {
    font: {
      primary: MID_BLUE3,
      secondary: '#fff'
    },
    border: {
      primary: GREY2,
      secondary: MID_BLUE3
    },
    background: {
      primary: OFF_WHITE3,
      secondary: MID_BLUE
    }
  },
  skeleton: {
    primary: 'rgb(165 163 163)'
  },
  onboardingTour: {
    background: ONBOARDING_BLUE,
    backButtonText: ONBOARDING_BLUE2,
    nextButton: LIGHT_GRAY2,
    nextButtonText: NAVY15
  },
  nestedSubmenu: {
    primary: '#fff'
  },
  tooltip: {
    primary: DARK_NAVY6,
    color: '#ffffff'
  },
  footerIcon: {
    "default": ACCENT_BLUE
  },
  success: {
    main: GREEN_PRIMARY,
    contrastText: '#fff'
  },
  chip: {
    primary: MID_BLUE2
  },
  info: {
    main: ONBOARDING_BLUE,
    contrastText: '#fff'
  },
  error: {
    main: ORANGE1,
    contrastText: '#fff'
  },
  warning: {
    main: YELLOW1,
    contrastText: DARK_NAVY6
  },
  tour: {
    background: '#F4F8FA',
    header: {
      background: MID_BLUE2
    },
    progress: {
      bar: GREEN_PRIMARY,
      background: GREY11,
      text: BABY_BLUE3
    },
    beacon: {
      background: MID_BLUE2,
      shadow: NAVY15
    },
    modal: {
      text: NAVY15,
      actions: {
        text: {
          primary: NAVY15,
          secondary: LIGHT_BLUE4
        },
        primary: LIGHT_GRAY2
      }
    },
    step: {
      text: WHITE,
      actions: {
        text: {
          primary: NAVY15,
          secondary: BABY_BLUE3
        },
        primary: LIGHT_GRAY2
      }
    },
    feature: {
      text: NAVY15,
      background: WHITE,
      checkbox: {
        border: '#9EC3CC',
        background: {
          completed: GREEN_PRIMARY,
          incomplete: '#EEF2F5'
        }
      }
    }
  }
};
export default attunedLightTheme;